import { notifications } from '@mantine/notifications';
import { useMutation } from '@tanstack/react-query'

export const mutateShowcaseCreate = () => {

    const mutation = useMutation({
        mutationKey: ['showcase-create'],
        mutationFn: async (formData) => {
            const res = await axios.post(route('studio.editor.api.showcases.store'), formData);
            return res;
        },
        onSuccess: async () => {
            notifications.show({
                color: 'green',
                title: 'Success',
                message: 'Created',
              })
        },
        onError: async ({ response }) => {

            notifications.show({
                color: 'red',
                title: 'Error',
                message: response?.data?.message || "",
              })
        }
    });
  
    return mutation;
}